/**
 * Lets the Velora desktop app navigate this window in-app: a `velora://`
 * deep link or the call pop's "Open chart" pushes a path here instead of
 * reloading the page, so nothing typed is lost. Renders nothing; does
 * nothing in a plain browser.
 *
 * The desktop main process has already checked the path is a same-origin
 * workspace path (apps/desktop `safeWorkspacePath`); this checks again.
 */
import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';
import { desktopBridge } from './bridge.js';

export function isInAppPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.includes('\\');
}

export function DesktopNavigation() {
  const router = useRouter();
  useEffect(() => {
    const bridge = desktopBridge();
    if (!bridge?.onNavigateRequest) return undefined;
    return bridge.onNavigateRequest((path) => {
      if (isInAppPath(path)) router.history.push(path);
    });
  }, [router]);
  return null;
}
